(function () {
    const tradeshowForm = /** @type {HTMLFormElement} */ (document.getElementById('tradeshow-form'));

    const tradeshowFormFirstNameInput = /** @type {HTMLInputElement} */ (tradeshowForm.querySelector("[name='first_name']"));
    const tradeshowFormLastNameInput = /** @type {HTMLInputElement} */ (tradeshowForm.querySelector("[name='last_name']"));
    const tradeshowFormEmailInput = /** @type {HTMLInputElement} */ (tradeshowForm.querySelector("[name='email']"));

    const tradeshowSubmitBtn = /** @type {HTMLElement} */ (document.getElementById('tradeshow-submit-btn'));
    const tradeshowResetBtnWrapper = /** @type {HTMLElement} */ (document.getElementById('tradeshow-reset-btn-wrapper'));
    const tradeshowResetBtn = /** @type {HTMLElement} */ (document.getElementById('tradeshow-reset-btn'));

    const tradeshowFormTitleDesktop = /** @type {HTMLElement} */ (document.getElementById('tradeshow-form-title-desktop'));
    const tradeshowFormSubtitleDesktop = /** @type {HTMLElement} */ (document.getElementById('tradeshow-form-subtitle-desktop'));
    const tradeshowFormDescriptionDesktop = /** @type {HTMLElement} */ (document.getElementById('tradeshow-form-description-desktop'));

    const tradeshowFormThankYouNameEl = /** @type {HTMLElement} */ (document.getElementById('tradeshow-thank-you-name'));
    const tradeshowFormThankYouEmailEl = /** @type {HTMLElement} */ (document.getElementById('thank-you-email'));

    /** @type {FormHandler} */
    let tradeshowFormHandler;
    window.addEventListener('DOMContentLoaded', () => {
        //Submit through the shared B2C lead-gen client call instead of the old divzero fetch.
        tradeshowFormHandler = new FormHandler(null, tradeshowForm, null, null, countryCode);
        tradeshowFormHandler.submitHandler = submitLeadGenForm;
        tradeshowFormHandler.onSuccess = tradeshowFormPostSuccess;
    });

    tradeshowResetBtn.addEventListener('click', () => {
        tradeshowFormHandler.resetForm();
        tradeshowSubmitBtn.classList.remove('d-none');
        tradeshowResetBtnWrapper.classList.add('d-none');

        tradeshowForm.classList.remove('d-none');
        tradeshowFormTitleDesktop.classList.remove('d-none');
        tradeshowFormSubtitleDesktop.classList.remove('d-none');
        tradeshowFormDescriptionDesktop.classList.remove('d-none');
    });

    function tradeshowFormPostSuccess() {
        tradeshowFormThankYouNameEl.innerText = tradeshowFormFirstNameInput.value + ' ' + tradeshowFormLastNameInput.value;
        tradeshowFormThankYouEmailEl.innerText = tradeshowFormEmailInput.value;

        tradeshowSubmitBtn.classList.add('d-none');
        tradeshowResetBtnWrapper.classList.remove('d-none');

        tradeshowForm.classList.add('d-none');
        tradeshowFormTitleDesktop.classList.add('d-none');
        tradeshowFormSubtitleDesktop.classList.add('d-none');
        tradeshowFormDescriptionDesktop.classList.add('d-none');

        const formWrapper = /** @type {HTMLElement} */ (document.querySelector('.tradeshow-form-wrapper'));
        const offset = formWrapper.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: offset, behavior: 'smooth' });
    }
})();
